export default "__VITE_ASSET__B0pnI$j0__"